import { SOURCE_SYNC_FIELD } from "constants/invoiceSourceSync";
import dayjs from "dayjs";
import { InvoiceSourceSync } from "types/Models/invoiceSourceSync";

type IsSourceSyncInLockPeriodArgs = {
  invoiceDate?: string | null;
  sourceSync: InvoiceSourceSync;
  lockDate?: string | null;
};

// Resync would rebook a locked period when either the Inkle or the provider invoice date is on or before the lock date
export const isSourceSyncInLockPeriod = ({
  invoiceDate,
  sourceSync,
  lockDate,
}: IsSourceSyncInLockPeriodArgs): boolean => {
  if (!lockDate) {
    return false;
  }
  const sourceInvoiceDate = sourceSync.changes.find(
    (change) => change.field === SOURCE_SYNC_FIELD.INVOICE_DATE
  )?.source;
  return [invoiceDate, sourceInvoiceDate].some(
    (date) => typeof date === "string" && !dayjs(date).isAfter(lockDate)
  );
};
